import { render, staticRenderFns } from "./EntityUsersPermissions.vue?vue&type=template&id=7511b972"
import script from "./EntityUsersPermissions.vue?vue&type=script&lang=js"
export * from "./EntityUsersPermissions.vue?vue&type=script&lang=js"
import style0 from "./EntityUsersPermissions.vue?vue&type=style&index=0&id=7511b972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports